import gql from 'graphql-tag'

import PriceFragment from '@Queries/cms/fragments/Price.fragment'
import AddToCartProductTacticFragment from '@Queries/tactics/AddToCartProductTactic.fragment'
import TacticRecommendationsFragment from '@Queries/tactics/TacticRecommendations.fragment'

export default gql`
  ${AddToCartProductTacticFragment}
  ${PriceFragment}
  ${TacticRecommendationsFragment}

  fragment ProductPageTacticFragment on ProductTactic {
    __typename
    ... on TacticAssortmentLadder {
      id
      items {
        id
        iconURL
        header {
          ...WordbookFragment
        }
        text {
          ...WordbookFragment
        }
      }
    }
    ... on TacticBlocks {
      id
      blocks {
        ...BlockContent
      }
    }
    ... on TacticBuildYourDiscount {
      id
      products {
        id
        name
        url
        primaryAsset: asset(tag: "primary") {
          url
        }
        variants {
          id
        }
      }
      items {
        price {
          ...PriceFragment
        }
        offers {
          productID
          offer {
            ...AddToCartProductTacticFragment
          }
        }
      }
    }
    ... on TacticBundleInfo {
      id
      bundlePrice {
        difference {
          ...MoneyContent
        }
        originalPrice {
          ...MoneyContent
        }
        price {
          ...MoneyContent
        }
      }
      bundleProducts {
        quantity
        productID
        product {
          id
          name
          type
          url
          image: asset(tag: "primary") {
            url
            dimensions {
              width
              height
            }
          }
          ...ProductSpecificationFragment
          masterVariant {
            id
            price {
              ...PriceFragment
            }
          }
        }
      }
      settings
    }
    ... on TacticComplementaryProducts {
      id
      products {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
    ... on TacticLinkedProductsColor {
      id
      color {
        type
        products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
    }
    ... on TacticLinkedProductsSizeAndVariation {
      id
      size {
        type
        products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
      variation {
        type
        products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
    }
    ... on TacticLooks {
      id
      looks {
        id
        ambassadorHandle
        asset {
          ...ReferenceContent
        }
        products {
          productID
          x
          y
        }
      }
      settings
      title {
        ...WordbookFragment
      }
    }
    ... on TacticMatchingVariant {
      id
      type
      title {
        ...WordbookFragment
      }
      tag {
        ...WordbookFragment
      }
      offer {
        ...AddToCartProductTacticFragment
      }
      productHeader {
        ...WordbookFragment
      }
      productID
      product {
        id
        name
        url
        primaryAsset: asset(tag: "primary") {
          url
        }
        masterVariant {
          price {
            currencyCode
            value
            format
            discount {
              currencyCode
              percent
              value
              format
            }
          }
        }
      }
    }
    ... on TacticOthersBought {
      id
      ...TacticRecommendationsFragment
    }
    ... on TacticOthersBoughtGrid {
      id
      ...TacticRecommendationsFragment
    }
    ... on TacticRecommendedForYou {
      id
      ...TacticRecommendationsFragment
    }
    ... on TacticRelatedProducts {
      id
      products {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
    ... on TacticRelativeDiscount {
      id
      productIDs
      products {
        id
        name
        primaryAsset: asset(tag: "primary") {
          url
        }
      }
      relativeDiscounts {
        quantity
        price {
          format
          discount {
            format
            value
          }
          value
        }
        percentage
      }
    }
    ... on TacticSimilarProducts {
      id
      products {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
    ... on TacticUpgradeWith {
      id
      items {
        type
        product {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
    }
  }
`
